import type { ApiResponse } from '@evi/shared';
import { api } from './api';
import type { OutreachEdits, OutreachSourceKind, OutreachView } from './propertyOutreachView';

export * from './propertyOutreachView';

/**
 * Contact the property (Warren, 4 Nov 2026, ruling R10). routes/admin/property-outreach.ts: EVI staff only, and a person's
 * press is the only thing that sends. Send never retries (the client retries GET only); the Api's compare-and-set holds a
 * double click to one send.
 */
const data = (r: Promise<ApiResponse<OutreachView>>) => r.then((x) => x.data as OutreachView);

export const draftOutreach = (source_kind: OutreachSourceKind, source_id: string) =>
  data(api.post('admin/property-outreach', { json: { source_kind, source_id } }).json());
export const listOutreach = (source_kind: OutreachSourceKind, source_id: string) =>
  api.get('admin/property-outreach', { retry: 0, searchParams: { source_kind, source_id } }).json<ApiResponse<OutreachView[]>>().then((x) => x.data as OutreachView[]);
export const getOutreach = (id: string) => data(api.get(`admin/property-outreach/${id}`, { retry: 0 }).json());
export const saveOutreach = (id: string, edits: Partial<OutreachEdits>) => data(api.patch(`admin/property-outreach/${id}`, { json: edits }).json());
export const sendOutreach = (id: string) => data(api.post(`admin/property-outreach/${id}/send`).json());
export const discardOutreach = (id: string) => data(api.post(`admin/property-outreach/${id}/discard`).json());
